var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 19,
    viewBox: "0 0 5 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5C1.83696 5 1.20107 4.76295 0.732234 4.34099C0.263393 3.91903 0 3.34674 0 2.75C0 2.15326 0.263393 1.58097 0.732234 1.15901C1.20107 0.737053 1.83696 0.5 2.5 0.5C3.16304 0.5 3.79893 0.737053 4.26777 1.15901C4.73661 1.58097 5 2.15326 5 2.75C5 3.34674 4.73661 3.91903 4.26777 4.34099C3.79893 4.76295 3.16304 5 2.5 5ZM2.5 11.75C1.83696 11.75 1.20107 11.5129 0.732234 11.091C0.263393 10.669 0 10.0967 0 9.5C0 8.90326 0.263393 8.33097 0.732234 7.90901C1.20107 7.48705 1.83696 7.25 2.5 7.25C3.16304 7.25 3.79893 7.48705 4.26777 7.90901C4.73661 8.33097 5 8.90326 5 9.5C5 10.0967 4.73661 10.669 4.26777 11.091C3.79893 11.5129 3.16304 11.75 2.5 11.75ZM2.5 18.5C1.83696 18.5 1.20107 18.2629 0.732234 17.841C0.263393 17.419 0 16.8467 0 16.25C0 15.6533 0.263393 15.081 0.732234 14.659C1.20107 14.2371 1.83696 14 2.5 14C3.16304 14 3.79893 14.2371 4.26777 14.659C4.73661 15.081 5 15.6533 5 16.25C5 16.8467 4.73661 17.419 4.26777 17.841C3.79893 18.2629 3.16304 18.5 2.5 18.5Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMenu);
export default __webpack_public_path__ + "static/media/phone_menu.a3f4c242c819ac4f0ff1010d3fc6918f.svg";
export { ForwardRef as ReactComponent };